import type { Annotation } from "../api/types";

/** Legacy object proposals stay in the inspector, never in the task lanes. */
export function isActivityLabel(a: Annotation): boolean {
  return a.payload?.type === "activity" || a.source !== "model" ||
    (a.review_status === "edited" && a.provenance?.plugin === "objects.yolox");
}
export function activityLevel(a: Annotation): "context" | "activity" {
  return a.payload?.level === "context" ? "context" : "activity";
}
export function currentActivity(annotations: Annotation[], time: number, level: "context" | "activity") {
  return annotations.filter(a => isActivityLabel(a) && activityLevel(a) === level && a.review_status !== "rejected" &&
    a.start_ns <= time && (a.end_ns ?? a.start_ns + 500_000_000) > time)
    .sort((a,b) => Number(b.source !== "model" || b.review_status !== "unreviewed") - Number(a.source !== "model" || a.review_status !== "unreviewed") || b.start_ns-a.start_ns)[0];
}
